import { Button as ChakraButton, ButtonProps as ChakraButtonProps } from '@chakra-ui/react';

type ButtonProps = ChakraButtonProps;

export const Button = (props: ButtonProps) => (
  <ChakraButton w="full" h="56px" borderRadius="12px" {...props} />
);
